import { z } from 'zod';

export const completeEnglishIqV2RequestSchema = z.object({
  idempotencyId: z.string().min(1).max(128),
  token: z.string().min(1),
});

export type ICompleteEnglishIqV2Request = z.infer<typeof completeEnglishIqV2RequestSchema>;
